// Minimal i18n (docs/app/SPEC.md, decision 7): reactive locale, flat dictionaries, t(key, params).
import axios from 'axios';
import { ref } from 'vue';
import en from './en';
import ru from './ru';

export const SUPPORTED_LOCALES = ['ru', 'en'];
export const DEFAULT_LOCALE = 'ru';

const STORAGE_KEY = 'locale';
const messages = { ru, en };
const intlLocales = { ru: 'ru-RU', en: 'en-US' };

function readStoredLocale() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return SUPPORTED_LOCALES.includes(stored) ? stored : null;
  } catch {
    return null;
  }
}

export const locale = ref(readStoredLocale() ?? DEFAULT_LOCALE);

function apply(value) {
  document.documentElement.lang = value;
  // Backend answers in the UI language (SetLocale middleware).
  axios.defaults.headers.common['X-Locale'] = value;
}

apply(locale.value);

export function setLocale(value) {
  if (!SUPPORTED_LOCALES.includes(value)) {
    return;
  }
  locale.value = value;
  apply(value);
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage blocked: the choice lives until reload, the profile still keeps it.
  }
}

export function intlLocale() {
  return intlLocales[locale.value];
}

/**
 * Translates a key; {name} placeholders are replaced from params. Missing keys fall back to ru, then to the key.
 */
export function t(key, params = {}) {
  const template = messages[locale.value][key] ?? messages[DEFAULT_LOCALE][key] ?? key;
  return template.replace(/\{(\w+)\}/g, (match, name) => (name in params ? String(params[name]) : match));
}
